import { render, staticRenderFns } from "./child_like_awaken.vue?vue&type=template&id=39d8cc66&scoped=true"
import script from "./child_like_awaken.vue?vue&type=script&lang=js"
export * from "./child_like_awaken.vue?vue&type=script&lang=js"
import style0 from "./child_like_awaken.vue?vue&type=style&index=0&id=39d8cc66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d8cc66",
  null
  
)

export default component.exports